/** Numele afișat pe ecranul de start. Înlocuiește-l când alegi numele jocului. */
export const GAME_NAME = 'NUME_JOC';

/** Frecvența fixă a fizicii: 2000 Hz (dt = 0,0005 s). */
export const PHYSICS_HZ = 2000;
export const PHYSICS_DT = 1 / PHYSICS_HZ;

/**
 * Câți pași poate recupera worker-ul într-o singură trecere (30 ms de simulare).
 * Peste această valoare simularea încetinește, în loc să mărească dt.
 */
export const MAX_STEPS_PER_TICK = 60;

/** Frecvența maximă de randare. */
export const FPS_LIMIT = 60;
export const FPS_LIMIT_ECO = 30;
